/**
 * Realiza o scroll para abixo até desaparecer o topbar.
 * É para ser usado dentro de uma opção do coletor
 */
export default function () {
  onMounted(() => {
    nextTick(() => {
      setTimeout(() => {
        const topbar: HTMLElement | null = document.querySelector(".topbar");
        if (topbar) {
          const heightTopBar = topbar.offsetHeight;
          window.scrollBy({ top: heightTopBar, behavior: "smooth" });
        }
        else {
          console.log("classe não encontrada");
        }
      }, 1);
    });
  });
}
